export enum StorageKind {
  Local = 'local',
  Session = 'session',
}

export const Storage = {
  canUse: (kind: StorageKind = StorageKind.Local): boolean => {
    return !!Storage.getStorageProvider(kind);
  },
  getStorageProvider: (kind: StorageKind): Storage | null => {
    try {
      if (typeof window === 'undefined') return null;
      return kind === 'local' ? window.localStorage : window.sessionStorage;
    } catch {
      return null;
    }
  },
  readString: (kind: StorageKind, key: string): string | null => {
    const storage = Storage.getStorageProvider(kind);
    if (!storage) return null;
    try {
      return storage.getItem(key);
    } catch {
      return null;
    }
  },
  writeString: (kind: StorageKind, key: string, value: string): void => {
    const storage = Storage.getStorageProvider(kind);
    if (!storage) return;
    try {
      storage.setItem(key, value);
    } catch {
      console.warn('Failed to write item to storage');
    }
  },
  readJson: <T>(kind: StorageKind, key: string, fallback: T): T => {
    const raw = Storage.readString(kind, key);
    if (!raw) return fallback;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  },
  writeJson: <T>(kind: StorageKind, key: string, value: T): void => {
    try {
      Storage.writeString(kind, key, JSON.stringify(value));
    } catch {
      console.warn('Failed to write item to storage');
    }
  },
};
